<div class="padding">
  <div>
    <h1>{{ 'consortium.vinsightBeta' | transloco }}</h1>
    <div class="flex-container">
      <div class="flex-item">
        <mat-card>
          <mat-card-content>
            <div class="flex-container">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
                <input matInput [disabled]="loading" data-testid="serial-number-input"
                  [placeholder]="'common.labels.serialNumber' | transloco" [(ngModel)]="serialNumber" />
                <button matSuffix mat-raised-button [disabled]="loading || !serialNumber"
                  (click)="onGetVINsightsClick()" color="primary" class="margin-sides-15"
                  [attr.aria-label]="'consortium.getVinsights' | transloco" data-testid="get-vinsights-button">
                  {{ 'consortium.getVinsight' | transloco }}
                </button>
              </mat-form-field>
            </div>
          </mat-card-content>
        </mat-card>
        <div [@slideDownOnly]="hasData ? 'visible' : 'hidden'">
          <div class="flex-container">
            <mat-card class="flex-item">
              <mat-card-content>
                @if(isDecodeError()) {
                  <lib-placeholder iconName="cancel" [condition]="true" iconClass="icon-error"
                  [message]="'consortium.serialNumberNotDecodable' | transloco"></lib-placeholder>
                } @else {
                  <div class="flex-container">
                    <div class="flex-item flex-container">
                      <span class="flex-item">{{ 'consortium.make' | transloco }}</span>
                      <span class="flex-item-2">{{ decodedInformation?.make ?? ('consortium.notDecoded' | transloco) }}</span>
                    </div>
                    <div class="flex-item flex-container">
                      <span class="flex-item">{{ 'consortium.model' | transloco }}</span>
                      <span class="flex-item-2">{{ decodedInformation?.model ?? ('consortium.notDecoded' | transloco)
                      }}</span>
                    </div>
                  </div>
                  <div class="flex-container">
                    <div class="flex-item flex-container">
                      <span class="flex-item">{{ 'consortium.trim' | transloco }}</span>
                      <span class="flex-item-2">{{ !!decodedInformation?.trim ?
                      decodedInformation?.trim : ('consortium.notDecoded' | transloco) }}</span>
                    </div>
                    <div class="flex-item flex-container">
                      <span class="flex-item">{{ 'consortium.year' | transloco }}</span>
                      <span class="flex-item-2">{{ decodedInformation?.year ?? ('consortium.notDecoded' | transloco) }}</span>
                    </div>
                  </div>
                }
              </mat-card-content>
            </mat-card>
            <mat-card class="flex-item">
              <mat-card-content>
                @if(criminalActivityResults === undefined) {
                  <lib-placeholder [condition]="true" iconName="help" iconClass="icon-info"
                  [message]="'consortium.noStolenVehicleChecksHaveBeen' | transloco"></lib-placeholder>
                } @else if(isCrimeCheckClear()) {
                  <lib-placeholder [condition]="isCrimeCheckClear()" iconName="check_circle"
                    iconClass="icon-success"
                  [message]="'consortium.stolenVehicleCheckIsClear' | transloco"></lib-placeholder>
                } @else if(!isCrimeCheckClear()) {
                  <lib-placeholder [condition]="!isCrimeCheckClear()" iconName="cancel"
                  iconClass="icon-error" [message]="getCrimeCheckInformation()"></lib-placeholder>
                }
              </mat-card-content>
            </mat-card>
          </div>
          @if(bubbles.length > 0) {
            <mat-card class="timeline-container">
              <mat-card-content>
                <mat-card-title>
                  <h4>{{ 'consortium.timelineEventsFound' | transloco: { count: timeline.length } }}</h4>
                </mat-card-title>
                <div class="timeline-line">
                  @for (bubble of bubbles; track bubble) {
                    <div class="bubble flex-container-center"
                      [ngClass]="selectedBubble === bubble ? 'selected-bubble' : ''"
                      [ngStyle]="{'left': bubble.x}" role="button" tabindex="0"
                      (click)="onBubbleClick(bubble)" (keydown.enter)="onBubbleClick(bubble)"
                      (keydown.space)="$event.preventDefault(); onBubbleClick(bubble)"
                      (focus)="onBubbleMouseEnter(bubble)" (blur)="onBubbleMouseLeave(bubble)"
                      (mouseenter)="onBubbleMouseEnter(bubble)" (mouseleave)="onBubbleMouseLeave(bubble)">
                      @if (showBubbleIcon(bubble)) {
                        <mat-icon>{{ getBubbleIcon(bubble)
                        }}</mat-icon>
                      } @else {
                        {{ bubble.events.length }}
                      }
                    </div>
                  }
                  @for (bubble of bubbles; track bubble) {
                    <div [ngStyle]="{'left': bubble.x}">
                      <div [@fadeInOut]="selectedBubble === bubble || (!selectedBubble && hoveredBubble === bubble) ? 'visible' : 'hidden'"
                        class="bubble-events" [ngStyle]="getBubbleXOffset(bubble)">
                        <table>
                          <tr>
                            <th scope="col"><span class="visually-hidden">{{ 'common.labels.warning' | transloco }}</span></th>
                            <th scope="col" class="bold event-text" style="text-align: center;">{{ 'consortium.event' | transloco }}</th>
                            @if (bubbleHasJurisdiction(bubble)) {
                              <th scope="col" class="bold event-text" style="text-align: center;">{{ 'common.labels.juris' | transloco }}</th>
                            }
                            <th scope="col" class="bold event-text" style="text-align: center;">{{ 'common.labels.date' | transloco }}</th>
                          </tr>
                          @for (event of bubble?.events; track event) {
                            <tr>
                              <td class="event-text">
                                @if(shouldShowWarningIcon(event)) {
                                  <mat-icon>warning</mat-icon>
                                }
                              </td>
                              <td class="event-text">
                                {{ formatEvent(event) }}
                              </td>
                              @if (bubbleHasJurisdiction(bubble)) {
                                <td class="event-text" style="text-align: center;">
                                  {{ event.jurisdiction }}
                                </td>
                              }
                              <td class="event-text">
                                {{event.activityDate | date:'yyyy-MM-dd':'UTC'}}
                              </td>
                            </tr>
                          }
                        </table>
                      </div>
                    </div>
                  }
                  <div class="bubble-date-start">
                    {{ bubbles[0].events[0].activityDate | date:'yyyy-MM-dd':'UTC' }}
                  </div>
                  @if(bubbles.length > 1) {
                    <div class="bubble-date-end">
                      {{ bubbles[bubbles.length - 1].events[bubbles[bubbles.length - 1].events.length
                      - 1].activityDate | date:'yyyy-MM-dd':'UTC' }}
                    </div>
                  } @else {
                    <div class="bubble-date-end">
                      {{ bubbles[0].events[0].activityDate | date:'yyyy-MM-dd':'UTC' }}
                    </div>
                  }
                </div>
                <div class="explanation-text">
                  <mat-icon>warning</mat-icon><span> {{ 'consortium.iconIndicatesAnEventDetectedOutside' | transloco }}</span>
                </div>
              </mat-card-content>
            </mat-card>
          } @else {
            <mat-card>
              <mat-card-content>
                <lib-placeholder iconName="help" iconClass="icon-info" [message]="'consortium.noEventsFound' | transloco" [condition]="true"></lib-placeholder>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
    </div>
  </div>

  @if(loading) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>